import { viewFromApi } from "@/components/FileViewer";
import { PenLine } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtT, fmtDur, ENTRY_ICON, VitalsChips } from "./ClientStayDialog";

export const fmtD = (v) => (v ? new Date(v).toLocaleDateString([], { dateStyle: "medium" }) : "—");

export function StayCard({ s, onSignature }) {
  return (
    <div className={`rounded-xl border p-3 ${!s.departed_at ? "border-emerald-300 bg-emerald-50/40" : "border-slate-200 bg-white"}`} data-testid={`history-stay-${s.id}`}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        <span className="font-semibold text-slate-900">{fmtD(s.arrived_at)}</span>
        <span className="text-slate-600">{fmtT(s.arrived_at)} → {s.departed_at ? fmtT(s.departed_at) : <b className="text-emerald-700">on site</b>}</span>
        <span className="font-display font-bold text-slate-900">{fmtDur(s.duration_minutes ?? s.minutes_so_far)}</span>
        {s.departed_at && onSignature && (
          <button onClick={() => onSignature(s)} data-testid={`history-sig-${s.id}`} className="ml-auto inline-flex items-center gap-1 text-xs text-primary hover:underline"><PenLine className="h-3.5 w-3.5" /> Signature</button>
        )}
      </div>
      <div className="mt-1 text-xs text-slate-500">
        Dropped off by <b className="text-slate-700">{s.dropoff_name || "—"}</b> (checked in by {s.arrived_by_name})
        {s.departed_at && <> · Picked up by <b className="text-slate-700">{s.pickup_name || "—"}</b> (checked out by {s.departed_by_name})</>}
      </div>
      {(s.arrival_note || s.departure_note) && <div className="mt-1 text-xs text-slate-600 italic">{[s.arrival_note, s.departure_note].filter(Boolean).map((n) => `“${n}”`).join(" · ")}</div>}
      {(s.entries || []).length > 0 && (
        <div className="mt-2 space-y-1">
          {s.entries.map((e) => { const I = ENTRY_ICON[e.type]; return (
            <div key={e.id} className={`flex items-start gap-2 rounded-md px-2 py-1 text-xs ${e.type === "incident" ? "bg-rose-50 text-rose-800" : "bg-slate-50 text-slate-700"}`}>
              {I && <I className="h-3.5 w-3.5 mt-0.5 shrink-0" />}<span className="flex-1">{e.type === "vitals" && e.data && Object.keys(e.data).length ? <VitalsChips data={e.data} note={e.text} /> : e.text}</span><span className="text-[10px] text-slate-400 shrink-0">{fmtT(e.at)} · {e.by_name}</span>
            </div>); })}
        </div>
      )}
    </div>
  );
}

export function SignatureDialog({ sig, onClose }) {
  if (!sig) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="signature-dialog">
        <DialogHeader><DialogTitle className="font-display">Escort signature · {sig.pickup_name}</DialogTitle></DialogHeader>
        {sig.pickup_signature ? <img src={sig.pickup_signature} alt="signature" className="w-full rounded-xl border border-slate-200 bg-white" /> : <div className="text-sm text-slate-500">No signature recorded.</div>}
        {sig.stay && <div className="text-xs text-slate-500">{sig.stay.client_name} · left {fmtT(sig.stay.departed_at)} on {fmtD(sig.stay.departed_at)}</div>}
      </DialogContent>
    </Dialog>
  );
}

export async function openStayReport(clientId, month) {
  return viewFromApi(api, `/clients/${clientId}/stay-report.pdf`, { params: { month }, title: `Stay report · ${month}`, filename: `stay-report-${month}.pdf`, type: "application/pdf" });
}

